var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-container"},[(_vm.isPc)?_c('PcPage',{attrs:{"policy-info":_vm.policyInfo}}):_c('MobilePage',{attrs:{"policy-info":_vm.policyInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }